module.exports = __webpack_public_path__ + "static/media/J8.819c823d.png";